import { Inject, Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { ApiModule } from './api.module';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { Store } from '@ngxs/store';
import { SessionStateModel, SessionState } from '../session';
import { buildAwsApi } from '../util.class';
import { SimNumbers } from 'src/app/change/shared/state/sim-change.action';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
/* eslint-disable */
export class SimApiService {
  keyMapAWS: any;

  constructor(
    private http: BaseApiService,
    @Inject(CORE_CONFIGURATION) private config,
    private _store: Store) {
    const { keyMapAWS }: SessionStateModel = this._store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
  }

  puk(msisdn: string): Observable<any> {
    return this.http.get({ path: `/ResourceInventoryManagementNg/v1/sim?msisdn=${msisdn}` });
  }

  counters(msisdn: string, hideError?: boolean): Observable<any> {
    const apiAWS = buildAwsApi(this.keyMapAWS, 'counter_list_fe', { msisdn: msisdn, includeCompany: true });

    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? `/v2/counters/sim/${msisdn}`,
      awsApi: apiAWS !== null,
      hideError,
    });
  }

  countersCompany(hideError?: boolean): Observable<any> {
    const apiAWS = buildAwsApi(this.keyMapAWS, 'counter_list_no_sim_fe', {});
    return this.http.get({
      apiBasePath: this.config.apiBasePath,
      path: apiAWS ?? `/v2/counters/company`,
      awsApi: apiAWS !== null,
      hideError,
    });
  }

  listNumber({ params }:SimNumbers): Observable<any>{
    const apiAWS = buildAwsApi(this.keyMapAWS,'company_assets', {delegationCustcode:params.delegationCustcode,category:params.category});

    return this.http.get({
      hideError: false,
      apiBasePath:  this.config.apiBasePath,
      path: apiAWS,
      awsApi: apiAWS !== null,
      
    });
  }
}
